import findLastIndex from "lodash/findLastIndex";

/**
 * Nullify empty values from an object or array.
 * @param value - The value to nullify
 * @returns The nullified value
 */
export const nullifyEmptyValues = (value: unknown): unknown => {
  if (Array.isArray(value)) {
    // Trim empty values from the end of the array
    const arr = value.map(nullifyEmptyValues);
    return arr.slice(0, findLastIndex(arr, (val) => val != null) + 1);
  }

  if (typeof value === "object" && value != null) {
    const objEntries = Object.entries(value)
      .map(([key, value]) => [key, nullifyEmptyValues(value)])
      .filter(([, value]) => value != null);

    return objEntries.length === 0 ? undefined : Object.fromEntries(objEntries);
  }

  return value === "" || value == null ? undefined : value;
};
